import { createSlice } from "@reduxjs/toolkit";
import { handleLoginThunk, handleLoginSsoThunk, refreshTokenThunk } from "../action/auth.action";
import { authInitialState } from "src/models/authentication/auth";

export const authSlice = createSlice({
  name: 'auth',
  initialState: authInitialState,
  reducers: {
    setLoginStateFromStorage: (state, action) => {
      state.loginState = true;
      state.token = action.payload;
    },
    logout: (state) => {
      state.loginState = false;
      state.logoutState = true;
      state.token = '';
      state.userData = null;
      localStorage.removeItem('userToken'); 
      localStorage.removeItem('refreshToken');
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(handleLoginThunk.fulfilled, (state, action) => {
        state.loginState = true; 
        state.logoutState = false;
        state.loginSso = false;
        state.userData = action.payload.data.data;
        state.token = action.payload.data.data.token; 
        localStorage.setItem('userToken', action.payload.data.data.token); 
        localStorage.setItem('refreshToken', action.payload.data.data.refreshToken);
        state.loading = false;
      })
      .addCase(handleLoginThunk.rejected, (state) => {
        state.loginState = false; 
        state.token = '';
        localStorage.removeItem('userToken'); 
        localStorage.removeItem('refreshToken');
        sessionStorage.clear();
        state.loading = false;
      })
      .addCase(handleLoginThunk.pending, (state) => {
        state.loading = true;
      })         
      .addCase(handleLoginSsoThunk.fulfilled, (state, action: any) => {
        state.loginState = true; 
        state.logoutState = false;
        state.loginSso = true;
        state.token = action.payload.data.data.token; 
        localStorage.setItem('userToken', action.payload.data.data.token); 
        localStorage.setItem('refreshToken', action.payload.data.data.refreshToken);
        state.loading = false;
      })
      .addCase(handleLoginSsoThunk.rejected, (state) => {
        state.loginState = false; 
        state.token = ''; 
        localStorage.removeItem('userToken'); 
        localStorage.removeItem('refreshToken');
        sessionStorage.clear();
        state.loading = false;
      })
      .addCase(handleLoginSsoThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(refreshTokenThunk.fulfilled, (state, action) => {
        state.token = action.payload.token;
        state.userData = action.payload.data;
        console.log(action.payload)
        localStorage.setItem('userToken', action.payload.data.token);
        localStorage.setItem('refreshToken', action.payload.data.refreshToken);
      })
      .addCase(refreshTokenThunk.rejected, (state) => {
        state.loginState = false;
        state.token = '';
        localStorage.removeItem('userToken');
        localStorage.removeItem('refreshToken');
        state.userData = null;
      })
      .addCase(refreshTokenThunk.pending, (state) => {
        state.loading = true;
      });
  },
});

export const { setLoginStateFromStorage, logout } = authSlice.actions;

export default authSlice.reducer;
